import React from "react";

const Additionals = ({ clientData }) => (
  <>
    {clientData.addNewSection.map(function (item, index) {
      return (
        <div className="new-section p-4" key={index} id={item.sectionSlug}>
          <div className="section-title">{item.heading}</div>
          <div
            className="new-section-content"
            dangerouslySetInnerHTML={{ __html: item.headingContent }}
          ></div>
          <div className="clearfix"></div>
        </div>
      );
    })}
  </>
);

export default Additionals;
